/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    SAVE: 'Sauvegarder',
    SUBMIT: 'Soumettre'
  },
  ERROR: {
    CANCEL_COUNTERPART: 'Erreur lors de l\'annulation de la contrepartie',
    COUNTERPART_DETAILS_SUBMIT:
      'Erreur lors de la soumission de la contrepartie',
    DELETE_ATTACHMENT: 'Erreur lors de la suppression de la pièce jointe',
    DELETE_LINK: 'Erreur lors de la suppression du lien',
    ERROR: 'Erreur',
    FILE_SIZE: 'Le fichier ne peut pas être plus grand que 8 Mo',
    MAX_FILES_UPLOAD: 'Tu ne peux pas télécharger plus de 8 Mo à la fois',
    PUBLISHED_AT_ERROR: 'Date de publication obligatoire'
  },
  HEADER: {
    APPROVED_BY: 'Approuvé par',
    ATTACHMENT: 'Pièces jointes',
    COMMENT: 'Commentaire',
    CONFIRMATION_DATE: 'Confirmation',
    CURRENT_PARTNER_TASKS: 'Partenaire actuel',
    DESCRIPTION: 'Description',
    END_DATE: 'Date de fin',
    LINK: 'Liens',
    MANAGER_COMMENT: 'Commentaire du gestionnaire',
    MONTH: 'Mois',
    PERIODICITY: 'Périodicité',
    PREVIOUS_PARTNER_TASKS: 'Partenaire précédent',
    REQUIRED: 'Obligatoire',
    START_DATE: 'Date de début',
    STATE: 'État',
    SUBMISSION_DATE: 'Soumission'
  },
  LABEL: {
    ATTACHMENTS: 'Pièces jointes',
    ATTACHMENTS_UPLOADED: 'Pièces jointes téléchargées',
    CANCEL_COUNTERPART: 'Annuler',
    CLOSE: 'Fermer',
    COMMENT: 'Commentaire',
    CONFIRM: 'Confirmer',
    DESCRIPTION: 'Description',
    FILTER_MONTH_APR: 'Avril',
    FILTER_MONTH_AUG: 'Août',
    FILTER_MONTH_DEC: 'Décembre',
    FILTER_MONTH_FEB: 'Février',
    FILTER_MONTH_JAN: 'Janvier',
    FILTER_MONTH_JUL: 'Juillet',
    FILTER_MONTH_JUN: 'Juin',
    FILTER_MONTH_MAR: 'Mars',
    FILTER_MONTH_MAY: 'Mai',
    FILTER_MONTH_NOV: 'Novembre',
    FILTER_MONTH_OCT: 'Octobre',
    FILTER_MONTH_SEP: 'Septembre',
    LINK: 'Lien',
    LINKS: 'Liens',
    LINKS_UPLOADED: 'Liens téléchargés',
    MONTH: 'Mois',
    PUBLISHED_AT: 'Date de publication',
    STATE: 'État',
    SUBMIT_COUNTERPART: 'Soumettre',
    YEAR: 'Année'
  },
  SENTENCE: {
    CANCEL_COUNTERPART_TEXT:
      'Es-tu sûr(e) de vouloir annuler la soumission de la contrepartie ?',
    CONFIRM_SUBMIT_COUNTERPART_TEXT:
      'Es-tu sûr(e) de vouloir soumettre la contrepartie ?',
    NO_ROWS_ATTACHMENT: 'Aucun pièces jointes'
  },
  SUCCESS: {
    ATTACHMENT_DELETED: 'Pièce jointe supprimée',
    CANCEL_COUNTERPART: 'Contrepartie annulée',
    COUNTERPART_DETAILS_SUBMIT:
      'Détails de la contrepartie soumise avec succès',
    LINK_DELETED: 'Lien supprimé',
    SUCCESS: 'Succès'
  },
  TOOLTIP: {
    ADD_LINK: 'Ajouter un lien',
    APPROVED_BY: 'Approuvé par',
    ATTACHMENT: 'Pièces jointes',
    COMMENT: 'Commentaire',
    CONFIRMATION_DATE: 'Date de confirmation',
    CURRENT_PARTNER_TASKS:
      'Nombre d\'enregistrements de la période actuelle à soumettre par le partenaire',
    DESCRIPTION: 'Description',
    END_DATE: 'Date de fin',
    LINK: 'Liens',
    MANAGER_COMMENT: 'Commentaire du gestionnaire',
    MONTH: 'Mois',
    PERIODICITY: 'Périodicité',
    PREVIOUS_PARTNER_TASKS:
      'Nombre d\'enregistrements de la période précédente à soumettre par le partenaire',
    REMOVE_LINK: 'Supprimer le lien',
    REQUIRED: 'Obligatoire',
    START_DATE: 'Date de début',
    STATE: 'État',
    SUBMISSION_DATE: 'Date de soumission'
  }
};
